import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';

import Home from './home.component';
import Policies from './policies.component';
import Conditions from './conditions.component';

export default class MainComponent extends React.Component{



    render = () => (
        <Router>
            <div>
                <Switch>
                    <Route exact path="/" component={Home} />
                    <Route exact path="/policies" component={Policies} />
                    <Route exact path="/conditions" component={Conditions} />
                    <Redirect path="*" to="/" />
                </Switch>
            </div>
        </Router>
    )
}